import React from "react"
import Section from "./section"
import DfbHeadline from "../ui-kit/dfb_headline"
import CCardTeaser from "../elements/c_card_teaser"
import { useGetNewsImage } from "../../hooks/useNewsFallbackImage"

const MCardGridTopic = ({ data }) => {
  const getNewsImage = useGetNewsImage()
  const { headline, image_info, collection, link_text } = data
  let cards

  const getIconType = type => {
    let iconType
    switch (type) {
      case "video":
        iconType = "video"
        break
      case "image":
        iconType = "camera"
        break
      default:
        iconType = ""
    }
    return iconType
  }

  if (image_info) {
    cards = image_info.map(image => {
      const icon = getIconType(image.image_info_type)
      return {
        description: image.image_info_file?.[0].description,
        headline: image.image_info_file?.[0].title,
        icon: icon,
        href: image.image_info_file?.[0].link?.url,
        image: image.image_info_file?.[0] || getNewsImage({}),
        topline: image.image_info_topline,
      }
    })
  } else {
    cards = collection.map(item => {
      const icon = getIconType(item.image_info_type)
      return {
        description: item.content.tx_headless_news_teaser,
        headline: item.content.title,
        href: item.full_slug,
        icon: icon,
        image: getNewsImage(item),
        topline: item.content.main_category?.title,
      }
    })
  }

  return (
    <Section
      baseClass="m-CardGrid m-CardGrid--topic"
      defaultPadding="large"
      defaultBgColor="grey"
      data={data}
    >
      <div className="m-CardGrid-wrapper">
        <div className="m-CardGrid-container">
          {headline && (
            <div className="c-Headline m-CardGrid-headline">
              <DfbHeadline headline={headline} headline_level="h2" />
            </div>
          )}
        </div>
        <div className="c-CardGrid">
          <div className="c-CardGrid-container">
            {cards?.map((card, index) => (
              <CCardTeaser
                key={index}
                image={card.image}
                icon={card.icon}
                topline={card.topline}
                headline={card.headline}
                description={card.description}
                anchor={link_text}
                href={card.href}
                add_class="m-CardGrid-card"
              />
            ))}
          </div>
        </div>
      </div>
    </Section>
  )
}

export default MCardGridTopic
